<template>
  <div>
    <br />
    <vs-card style="border-radius: 20px">
      <vs-row>
        <vs-icon icon="manage_accounts" class="ml-2" />
        <p class="mt-1 ml-2">
          Vendor associations - Below is a list of Vendors this Asset is
          accsociated with.
        </p>
        <vs-spacer />
        <vs-button
          radius
          color="dark"
          type="line"
          icon="qr_code_scanner"
          class="mr-2"
        />
        <vs-button
          radius
          color="dark"
          type="line"
          icon="settings"
          class="mr-2"
        />
      </vs-row>
      <b-table></b-table>
      <vs-divider />
      <vs-button style="border-radius: 20px" v-b-modal.associate-vendors
        >Associate Vendors</vs-button
      >
    </vs-card>

    <b-modal id="associate-vendors" centered size="lg">
      <template #modal-title>
        <h3>Pick Vendors</h3>
      </template>
      <template #modal-header-close>
        <vs-button icon="close" style="border-radius: 20px" color="red" />
      </template>
      <template>
        <p>
          Please choose which Vendors you would like to associate this Vendors
          with.
        </p>
        <br />
        <vs-row>
          <vs-spacer />
          <vs-input
            class="mr-2"
            icon-after="true"
            icon="search"
            placeholder="Search"
            v-model="value1"
          />
        </vs-row>
        <br />
        <vs-row>
          <vs-spacer />
          <a href="#" class="mr-3">Collapse All</a>
          <a href="#" class="mr-3">Deselect All</a>
          <a href="#" class="mr-3">Select All</a>
        </vs-row>
        <br />
        <vs-card style="border-radius: 10px" actionable>
          <div @click="collapsestatus = !collapsestatus">
            <vs-icon
              icon="play_arrow"
              class="pb-1 pr-2"
              v-if="collapsestatus == false"
            />
            <vs-icon
              icon="play_arrow"
              class="pb-1 mr-2"
              style="transform: rotate(90deg)"
              v-if="collapsestatus != false"
            />
            <vs-icon icon="apartment" class="pb-1 pr-2" />
            GGWC
          </div>
        </vs-card>
        <vs-card
          style="
            width: 95%;
            border-radius: 10px;
            margin-left: 5%;
            margin-top: -2%;
          "
          v-if="collapsestatus == true"
        >
          <div>
            <vs-icon
              icon="play_arrow"
              class="pb-1 pr-2"
              v-if="collapsestatus == false"
            />
            <vs-icon
              icon="play_arrow"
              class="pb-1 mr-2"
              style="transform: rotate(90deg)"
              v-if="collapsestatus != false"
            />
            <vs-icon icon="apartment" class="pb-1 pr-2" />
            GGWC
          </div>
        </vs-card>
      </template>
      <template #modal-footer>
        <vs-row>
          <vs-button
            icon="add"
            style="border-radius: 20px; width: 20%"
            v-b-modal.create-vendor
            >Create Vendor</vs-button
          >
          <vs-spacer />
          <vs-button
            style="border-radius: 20px; width: 10%"
            @click="$bvModal.hide('associate-vendors')"
            >Select</vs-button
          >
        </vs-row>
      </template>
    </b-modal>
    <b-modal id="create-vendor" centered size="lg">
      <template #modal-title>
        <h3>Add a Vendor</h3>
        <p>The new vendor will be...</p>
      </template>
      <template #modal-header-close>
        <vs-button icon="close" style="border-radius: 20px" color="red" />
      </template>
      <template>
        <vs-col>
          <vs-radio
            v-model="typenewvendor"
            vs-name="typenewvendor"
            :vs-value="true"
            style="justify-content: start"
          >
            Blank Template
          </vs-radio>

          <vs-radio
            v-model="typenewvendor"
            vs-name="typenewvendor"
            :vs-value="false"
            style="justify-content: start"
          >
            Copy from an axisting Template
          </vs-radio>

          <br />

          <vs-divider />

          <br />

          <vs-input label="New Template's Name" v-model="value1" />

          <div v-if="typenewvendor == false">
            <vs-row class="mt-3 ml-1">
              <p class="mt-2">
                Pick a PM Template to copy form your location or even yout
                fellow manager's location
              </p>
              <vs-spacer />
              <vs-input
                class="mr-3"
                icon-after="true"
                icon="search"
                placeholder="What are you looking for?"
                v-model="value1"
              />
            </vs-row>
            <vs-collapse
              v-for="item in 7"
              :key="item"
              style="margin-bottom: -30px"
            >
              <vs-collapse-item>
                <div slot="header" class="divcard">
                  <br />
                  <vs-row>
                    <vs-icon
                      icon="folder"
                      color="dark"
                      size="30px"
                      class="ml-2"
                    ></vs-icon>
                    <p class="ml-3 mt-2">WO{{ item }}</p>
                  </vs-row>
                </div>
                <vs-card class="cardshadow ml-5" @click="this.cardcolor = red"
                  >test2</vs-card
                >
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </vs-col>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      collapsestatus: true,
      typenewvendor: true,
    };
  },
  methods: {
    // status() {
    //   console.log("d");
    //   this.collapsestatus = !this.collapsestatus
    //   console.log(this.collapsestatus ,"test");
    // },
  },
};
</script>

<style></style>
